export const extractDataFromElement = <T>(
  element: Element | undefined | null,
  attribute: string
): T | undefined => {
  try {
    if (!element) return undefined;
    const attr = element.getAttribute(attribute)?.trim() as string;
    const decoded = atob(attr);

    const data: T | undefined = JSON.parse(decoded);
    return data;
  } catch (e) {
    return undefined;
  }
};
